import { ICreateDeal, IDeal } from "features/Deals/interfaces";
import { apiClient } from "lib/apiClient";

export const addDeal = async (request: ICreateDeal): Promise<IDeal> => {
  const response = await apiClient.post("/deals", request);

  return response.data;
};
